import { render } from "./OvApplicationsView.vue?vue&type=template&id=2db88a26&scoped=true"
import script from "./OvApplicationsView.vue?vue&type=script&lang=js"
export * from "./OvApplicationsView.vue?vue&type=script&lang=js"

import "./OvApplicationsView.vue?vue&type=style&index=0&id=2db88a26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db88a26"],['__file',"src/views/overlatelser/OvApplicationsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2db88a26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2db88a26', __exports__)) {
    api.reload('2db88a26', __exports__)
  }
  
  module.hot.accept("./OvApplicationsView.vue?vue&type=template&id=2db88a26&scoped=true", () => {
    api.rerender('2db88a26', render)
  })

}


export default __exports__